module.exports = __webpack_public_path__ + "img/teac_angel.6eccbe9f.png";